import { CSSProperties } from "react";

export const XIntrigueCardSvg = ({
  width,
  style,
}: {
  width: number;
  style?: CSSProperties;
}) => {
  return (
    <svg
      style={style}
      width={width}
      height={(width / 26) * 38}
      viewBox="0 0 26 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_di_219_435)">
        <rect
          x="1"
          y="1"
          width="24"
          height="36"
          rx="1"
          fill="url(#paint0_linear_219_435)"
        />
        <rect
          x="1.5"
          y="1.5"
          width="23"
          height="35"
          rx="0.5"
          stroke="white"
          strokeOpacity="0.92"
        />
      </g>
      <g filter="url(#filter1_i_219_435)">
        <path
          d="M9.17604 14L10.5667 5L11.0303 16C9.79412 16.6667 6.85821 18.9 6.85821 20.5C6.85821 22.5 10.7213 23.3333 12.421 24C7.54908 24.1946 3.37809 24.8101 4.07681 19.5C5.18936 17.1 7.93986 14.8333 9.17604 14Z"
          fill="#F1D891"
        />
        <path
          d="M21.6923 14C20.7652 12 15.0479 12.3333 12.8846 13C14.4298 13.8333 18.4474 13.5 18.9109 15C19.3745 16.5 15.975 20.5 14.7388 21.5L15.2024 32L17.0567 22C18.7564 19.6667 23.2016 17.2558 21.6923 14Z"
          fill="#F1D891"
        />
        <ellipse cx="12.8846" cy="18.5" rx="2.31783" ry="2.5" fill="#F1D891" />
      </g>
      <defs>
        <filter
          id="filter0_di_219_435"
          x="0"
          y="0"
          width="26"
          height="38"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="0.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_219_435"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_219_435"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="1"
            operator="erode"
            in="SourceAlpha"
            result="effect2_innerShadow_219_435"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="0.5" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.67 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect2_innerShadow_219_435"
          />
        </filter>
        <filter
          id="filter1_i_219_435"
          x="4"
          y="5"
          width="18"
          height="27"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="1" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.258333 0 0 0 0 0.197506 0 0 0 0 0.024757 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_219_435"
          />
        </filter>
        <linearGradient
          id="paint0_linear_219_435"
          x1="13"
          y1="1"
          x2="13"
          y2="37"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#716238" />
          <stop offset="0.109375" stopColor="#4F3E11" />
          <stop offset="0.489583" stopColor="#352703" />
          <stop offset="0.911458" stopColor="#4F3E11" />
          <stop offset="1" stopColor="#716238" />
        </linearGradient>
      </defs>
    </svg>
  );
};
